var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgClose(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "20px",
    height: "20px",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "\\u2705-Feather-(Neutral)",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Cockpit-Navigation-open",
    transform: "translate(-30.000000, -30.000000)",
    fill: "#145685"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Gemeindenk\\xFCrzel"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Close",
    transform: "translate(30.000000, 30.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-6"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-Copy",
    transform: "translate(10.000000, 10.000000) rotate(45.000000) translate(-10.000000, -10.000000) ",
    x: -2,
    y: 9,
    width: 24,
    height: 2
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-Copy-3",
    transform: "translate(10.000000, 10.000000) rotate(-45.000000) translate(-10.000000, -10.000000) ",
    x: -2,
    y: 9,
    width: 24,
    height: 2
  })))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClose);
export default __webpack_public_path__ + "static/media/close.b08759a4455c558d293e9a5b0bf8bbb8.svg";
export { ForwardRef as ReactComponent };